<template>
  <div class="job-lang-skills">
    <job-lang-skill-header :type="type" />
    <div class="jd-section__items">
      <job-lang-skill-item
        v-for="(skill, i) in skills"
        :key="`JobLanguage${type}SkillItem${i}`"
        class="jd-section__item"
        :level="skill.level"
        :name="skill.name"
      />
    </div>
  </div>
</template>

<script>
import JobLanguageSkillHeader from './jobLanguageSkillHeader'
import JobLanguageSkillItem from './jobLanguageSkillItem'

export default {
  components: {
    'job-lang-skill-header': JobLanguageSkillHeader,
    'job-lang-skill-item': JobLanguageSkillItem,
  },
  props: {
    skills: {
      default: () => [],
      type: Array,
    },
    type: {
      default: 'spoken',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-lang-skill {
  @apply flex items-center text-sm;
}
>>> .job-lang-skill__label {
  @apply flex-grow flex items-center;
}
>>> .job-lang-skill__level {
  @apply flex-shrink-0 flex items-center w-shift-item ml-2 text-base;
  /* width: 7em; /* (5 icons * 1em + 4 gaps * 0.5em) */

  & span {
    @apply text-xs;
  }
}

@screen desktop {
  >>> .job-lang-skill__level {
    @apply w-shift-item-desktop text-xl;
  }
  >>> .job-lang-skill__level span {
    @apply text-sm;
  }
}
</style>
